var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.layout,{tag:"component"}),(true)?_c('scroll-to-top'):_vm._e(),(!!_vm.user)?_c('InactivityTimer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }